import Swal from "sweetalert2";


export const notificationAlert = (type: string, txt: string) => {
    Swal.fire({
        title: type,
        text: txt,
        confirmButtonText: '닫기'
    })
}